import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface headerProps {
  title: any;
  component?: any;
  children?: React.ReactNode;
}

const CustomHeader = (props: headerProps) => {
  const { title, component } = props;
  const { themeMode } = useSelector((state: RootState) => state.themeSlice);
  return (
    <Box
      className="title-bar"
      sx={{
        // boxShadow: "0 1px 3px #c7c9c8",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 3,
        minHeight: "65px",
        transform: "translateY(-12px)",
        // background: themeMode === "dark" ? "#101418 !important" : "#fff",
      }}
    >
      {component}
      <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      {props.children}
    </Box>
  );
};

export default CustomHeader;

// const countDown = () => {
//   const currentDate = new Date().getTime();
//   const deadline = new Date().setHours(15, 30, 0);
//   const diff = (deadline - currentDate);
//   const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//   const seconds = Math.floor((diff % (1000 * 60)) / 1000);
//   return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
// }
